import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    weather:null,
    menuList:null,
    queryResult:null
  },
  mutations: {
    setStateWeather:function (state,weather) {
      state.weather = weather
    },
    setStateMenuList:function (state,menuList) {
      state.menuList = menuList;
    },
    setQueryResult:function (state,queryResult) {
      state.queryResult = queryResult ;
    }
  },
  getters:{
    getStateWeather:function (state) {
      return state.weather
    },
    getStateMenuList:function (state) {
      return state.menuList
    },
    getStateQueryResult:function (state) {
      return state.queryResult
    }
  },
  actions: {
  },
  modules: {
  }
})
